import type { AppMode } from '@iheartjane/types';
import type { DeepReadonly } from 'ts-essentials';

import { useCustomerSelector } from '@jane/monolith/customer/redux';
import { selectEmbeddedApp } from '@jane/monolith/customer/redux/embeddedApp';
import { selectStore } from '@jane/monolith/customer/redux/store';
// eslint-disable-next-line no-restricted-imports
import type { Store } from '@jane/shared/models';
import { useEcommApp } from '@jane/shared/providers';

export const isGuestCheckoutEnabled = ({
  store,
  appMode,
  disableAuthFeatures,
}: {
  appMode: AppMode;
  disableAuthFeatures: boolean;
  store?: DeepReadonly<Store> | null;
}) =>
  Boolean(
    appMode === 'headless' ||
    disableAuthFeatures ||
    !store ||
    !store.guest_checkout_setting?.disabled
  );

export const useGuestCheckoutEnabled = () => {
  const { store } = useCustomerSelector(selectStore);
  const { appMode } = useEcommApp();
  const { disableAuthFeatures } = useCustomerSelector(selectEmbeddedApp);

  return isGuestCheckoutEnabled({
    store,
    appMode,
    disableAuthFeatures,
  });
};
